import { Directive, Input, OnInit, AfterContentInit } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';

import { CurrentUserService } from '../../user/services/current-user.service';
import { User } from '../../user/models/user';

@Directive({ selector: '[bizPermissionRequired]' })
export class PermissionRequiredDirective implements OnInit {
    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private currentUserService: CurrentUserService) { }

    _permissions: string | string[];
    @Input() set bizPermissionRequired(value: string | string[]) {
        this._permissions = value;
        this.detectAccess();
    }

    _type: string;
    @Input() set bizPermissionRequiredType(value: string) {
        this._type = value;
        this.detectAccess();
    }

    _evaluator: Function = undefined;
    @Input() set bizPermissionRequiredEvaluator(value: Function) {
        this._evaluator = value;
        this.detectAccess();
    }

    _trigger: any = undefined;
    @Input() set bizPermissionRequiredTrigger(value: any) {
        this._trigger = value;
        this.detectAccess();
    }

    ngOnInit() {
        this.currentUserService.userChangedObserver.subscribe(() => this.detectAccess());
        this.detectAccess();
    }

    detectAccess() {
        let permissionsToCheck: string[];
        if (Array.isArray(this._permissions)) {
            permissionsToCheck = this._permissions;
        }
        else {
            permissionsToCheck = [this._permissions];
        }

        let hasAccess: boolean = false;
        const currentUser: User = this.currentUserService.getCurrentUser();
        if (currentUser) {
            if (this._type == 'And') {
                // All of the permissions are required for this item to be shown.
                hasAccess = permissionsToCheck.every(p => this.checkPermission(p, currentUser));
            }
            else {
                // At least one of the permissions are required for this item to be shown.
                hasAccess = permissionsToCheck.some(p => this.checkPermission(p, currentUser));
            }
        }

        this.viewContainer.clear();

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    checkPermission(permission: string, user: User): boolean {
        // If permission is empty, the allow access. This is required by the menu as those
        // menu items with no permission requirement should be available for all users.
        let hasPermission: boolean = (permission === '') || User.hasPermission(permission, user);

        // If an evaluator is set, then allow it to override the permission grant.
        if (this._evaluator) {
            hasPermission = this._evaluator(permission, user, hasPermission, this._trigger);
        }

        return hasPermission;
    }
}